const MODAL_TYPE = {
  EDIT: 'EDIT',
  CONFIRM_DELETE: 'CONFIRM_DELETE',
};

export default MODAL_TYPE;
